import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Form,
  Row,
  Col,
  Button,
  Input,
  Label,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

// Backend
import { postSubproductTypeList } from "connection/backend";

import { Link, useHistory } from "react-router-dom";

const SubproductCreate = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alert1, setAlert1] = useState(false);

  const [formData, setFormData] = useState({ name: "" });
  const { name } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const redirect = () => {
    history.push("/subproducts");
  };

  const postSubproductType = async () => {
    try {
      setLoading(true);
      const subproduct = {
        name: name,
        sub: true,
      };
      const response = await postSubproductTypeList(subproduct);
      if (response.status === 201) {
        setLoading(false);
        setAlert(true);
      } else {
        setLoading(false);
        setAlert1(true);
      }
    } catch (error) {
      setLoading(false);
      setAlert1(true);
      console.error("Error al crear el subproducto", error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    postSubproductType();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Subproductos </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Subproductos"} />
          {loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {alert ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  El subproducto se ha agregado correctamente.
                </SweetAlert>
              ) : null}
              {alert1 ? (
                <SweetAlert
                  title="¡Error!"
                  danger
                  showConfirm={true}
                  onConfirm={() => {
                    setAlert1(false);
                  }}
                >
                  Ocurrió un error al agregar el subproducto, intente
                  nuevamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Nuevo subproducto</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={5}>
                        <div className="input-group mb-1">
                          <span className="input-group-text">
                            <i className="bx bx-receipt bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Nombre"
                              name="name"
                              id="name"
                              value={name}
                              onChange={onChange}
                              required
                            />
                            <Label for="name">Nombre</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-4 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/subproducts">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Crear
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SubproductCreate;
